import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Fulltime } from './fulltime.interface';
import { FulltimeService } from './fulltime.service';

const service = new FulltimeService();

export interface FulltimeState {}

const FulltimeStore: Module<FulltimeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createFulltime(context: any, payload: { companyJointCommitteeId: number; fulltime: Fulltime }) {
         return await service.postFulltime(payload.companyJointCommitteeId, payload.fulltime);
      },
      async changeFulltime(context: any, payload: { companyJointCommitteeId: number; fulltimeId: number; fulltime: Fulltime }) {
         return await service.putFulltime(payload.companyJointCommitteeId, payload.fulltimeId, payload.fulltime);
      },
      async deleteFulltime(context: any, payload: { companyJointCommitteeId: number; fulltimeId: number }) {
         return await service.deleteFulltime(payload.companyJointCommitteeId, payload.fulltimeId);
      },
      async archiveFulltime(context: any, payload: { companyJointCommitteeId: number; fulltimeId: number }) {
         return await service.archiveFulltime(payload.companyJointCommitteeId, payload.fulltimeId);
      },
      async restoreFulltime(context: any, payload: { companyJointCommitteeId: number; fulltimeId: number }) {
         return await service.restoreFulltime(payload.companyJointCommitteeId, payload.fulltimeId);
      },
   },
};

export default FulltimeStore;
